import { initToltyClientErrors, reportToltyClientError } from "./toltySentry";
import { showBootError } from "./lib/bootError";

void initToltyClientErrors();

// Shared dev chunks need the React refresh preamble first. Catch failures before React mounts.
// Invoke the entry explicitly: an empty cached module must fail visibly instead
// of resolving an undefined startup promise and leaving the splash up forever.
void import("./main")
  .then(({ startup }) => startup())
  .catch((error: unknown) => {
    reportToltyClientError(error);
    showBootError(error);
  });
